export const edit = [{
    title: "Explicación Detallada de la edición de los Campos del Contrato de Tokenización Inmobiliaria",
    value: `
   **1. Inicio de la práctica**  
Bienvenido a esta lección. Vamos a copiar el contrato del activo real (off-chain) y colocarlo dentro de nuestro contrato inteligente en Solidity.

[Ver contrato ERC20 en GitHub Gist](https://gist.githubusercontent.com/Tootyr/8c2afcc5fa222de03444c2b05a1bf0fd/raw/f75f6559a36a4451b4a77cc302a908f79d127d1e/TootyrToken)



    
    ---
**2. Información personalizada**  
En la lección anterior editaste el contrato off-chain con tu propia información (nombre del token, símbolo, valor, etc.).  
Asegúrate de tener ese texto ya modificado listo para copiar.
    
**Fragmentos editables principales:**
    \`\`\`solidity
    // SPDX-License-Identifier: MIT
    pragma solidity ^0.8.0;
    
    /// @title MyRealToken (MRT) - Token ERC20 para bienes raíces
    /// @author [Tu Nombre]
    /// @notice Contrato educativo para pruebas y despliegue en Polygon o Sepolia
    
    // ...resto del contrato...
    string public name = "MyRealToken";    // Cambia aquí el nombre
    string public symbol = "MRT";          // Cambia aquí el símbolo
    uint8 public decimals = 18;            // Mantén 18 decimales
    uint public override totalSupply;
    
    constructor() {
        totalSupply = 1_000_000 * 10 ** uint(decimals);  // Cambia aquí la cantidad de tokens
        balances[msg.sender] = totalSupply;               // Cambia msg.sender si asignas a otra dirección
        emit Transfer(address(0), msg.sender, totalSupply);
    }
    // ...resto del contrato...
    \`\`\`
    
    
    
**3. Copiar el contrato editado**  
Selecciona y copia todo tu contrato de activo real que preparaste previamente. Esta información será insertada dentro del contrato inteligente Solidity.
    
**4. Pegar en el archivo Solidity**  
Abre tu archivo Solidity en Sublime Text (u otro editor). Ubica la línea 18 del contrato y pega allí tu contrato off-chain. Ese será el primer bloque real insertado dentro de tu contrato Solidity.

![Logo del proyecto](https://raw.githubusercontent.com/AppsDevsLeon/ImagesProject/refs/heads/main/12-1.png)

 
    
**5. Modificar el nombre del contrato**  
Ve a la definición del contrato principal y **cambia el nombre**:
    \`\`\`solidity
    contract MyRealToken is IERC20, Owned { // Antes: TootyrToken
        // ...
    }
    \`\`\`
    
    ---
    
**6. Cambiar el símbolo del token**  
 Cambia el símbolo original por el que hayas elegido (3 o 4 letras):
    \`\`\`solidity
    string public symbol = "MRT"; // Antes: "TRT"
    \`\`\`
    
    ---
    
 **7. Asignar el nombre del token**  
 Cambia el nombre público del token por el que hayas definido para tu activo:
    \`\`\`solidity
    string public name = "MyRealToken"; // Ejemplo
    \`\`\`
    
    ---
    
 **8. Ajustar la cantidad total de tokens**  
 Edita la cantidad total de tokens (supply):
    \`\`\`solidity
    totalSupply = 1_000_000 * 10 ** uint(decimals); // 1 millón de tokens
    \`\`\`
    
    ---
    
 **9. Mantener decimales estándar**  
 La cantidad de decimales debe mantenerse en 18, ya que es lo estándar para tokens ERC20.
    
    ---
    
**10. Actualizar los comentarios del encabezado**  
 Edita el bloque de comentarios del encabezado para reflejar tu nuevo token y autoría:
    \`\`\`solidity
    /// @title MyRealToken — por [Tu Nombre] [Año]
    \`\`\`
    
    ---
    
 **11. Revisar el nombre del token en todo el contrato**  
 Revisa que en todo el contrato (y especialmente en el constructor y funciones auxiliares) se use correctamente el nombre y símbolo editados.
    
    ---
    
 **12. Asignar dirección de wallet**  
 En el constructor puedes cambiar la dirección que recibe los tokens:
    \`\`\`solidity
    balances[0xTuWalletAddress] = totalSupply; // En vez de balances[msg.sender]
    \`\`\`
    
    ---
    
 **13. Verificar dirección**  
Asegúrate de copiar bien tu dirección desde MetaMask o MyEtherWallet y reemplázala correctamente para evitar errores de asignación.

![Logo del proyecto](https://raw.githubusercontent.com/AppsDevsLeon/ImagesProject/refs/heads/main/26-2.png)
    ---
    
**14. Verificar decimales y total supply**  
Asegúrate de que la variable \`decimals\` esté en 18 y que el \`totalSupply\` refleje 1 millón con 18 decimales:
    \`\`\`solidity
    uint8 public decimals = 18;
    totalSupply = 1_000_000 * 10 ** 18;
    \`\`\`
    
    ---
    
    `
}];

export default edit;
